import React from "react";
import { Link } from "react-router-dom";
import InputSelect from "components/atoms/InputSelect";

// Kondisi & Terapi melekat pada Rule, bukan langsung pada Version.
// `rules` = Rule[] dari GET /standard-treatment-rules (tanpa kondisi/terapi).
const RuleSelector = ({ rules, selectedId, onSelect, versionId, disabled }) => {
  const options = rules.map((r) => ({
    // name dari backend sudah diawali kode rule (mis. "A18 — …").
    label: `${r.name} · #${r.source_rule_seq}${r.is_active ? "" : " (nonaktif)"}`,
    value: r.id,
  }));
  const rule = rules.find((r) => r.id === selectedId);

  return (
    <div className="mps-rule-bar">
      <div className="mps-rule-select">
        <InputSelect
          label={`Rule (${rules.length})`}
          isClearable={false}
          disabled={disabled}
          data={options}
          value={options.find((o) => o.value === selectedId) || null}
          onChange={(sel) => sel?.value && onSelect(sel.value)}
        />
      </div>
      {rule && (
        <div className="mps-rule-meta">
          <span className="mps-pill is-neutral" title="Hanya disimpan; evaluasi tidak memakainya">
            Prioritas {rule.priority}
          </span>
          <span className={`mps-pill ${rule.is_active ? "is-success" : "is-neutral"}`}>
            {rule.is_active ? "Aktif" : "Nonaktif"}
          </span>
          <Link className="mps-link" to={`/standard-treatment/rules/${rule.id}`}>
            Detail rule
          </Link>
          <Link className="mps-link" to={`/standard-treatment/rules?version_id=${versionId}`}>
            Kelola rules
          </Link>
        </div>
      )}
    </div>
  );
};

export default RuleSelector;
